import { useEffect } from 'react';
import { App as AntdApp, ConfigProvider } from 'antd';
import csCZ from 'antd/locale/cs_CZ';
import enUS from 'antd/locale/en_US';

import { THEME, THEME_REDESIGN } from '@config';

import { useLanguage } from '@hooks';

import { useRedesign } from '../featureFlags/useRedesign';

const WithAntdConfig = ({ children }: React.PropsWithChildren) => {
  const language = useLanguage();
  const redesign = useRedesign();

  useEffect(() => {
    const root = document.documentElement;
    if (redesign) {
      root.dataset.theme = 'redesign';
    } else {
      delete root.dataset.theme;
    }
  }, [redesign]);

  let locale;
  switch (language) {
    case 'cs': {
      locale = csCZ;
      break;
    }
    case 'en': {
      locale = enUS;
      break;
    }
    default: {
      locale = enUS;
      break;
    }
  }

  const theme = redesign ? THEME_REDESIGN : THEME;

  return (
    <ConfigProvider locale={locale} theme={theme}>
      <AntdApp>{children}</AntdApp>
    </ConfigProvider>
  );
};

WithAntdConfig.THEME = THEME;

export default WithAntdConfig;
